import type { TElement } from 'platejs';
import { z } from 'zod';

/**
 * Spread into a trigger node that a button opened, where the user never typed the trigger
 * character. Dismissing that picker puts back only what was typed into its search.
 */
export const OPENED_WITHOUT_TYPING = { openedWithoutTyping: true } as const;

/** Whether the user typed this trigger's character, so dismissing it should put it back. */
export function getWasTriggerTyped(element: TElement): boolean {
  return element.openedWithoutTyping !== true;
}

/** Which screen the skill picker opens on when the `@` picker hands off to it. */
export const SKILL_PICKER_VIEWS = { List: 'list', NewSkill: 'new-skill' } as const;

export type SkillPickerView = (typeof SKILL_PICKER_VIEWS)[keyof typeof SKILL_PICKER_VIEWS];

const CONTEXT_ORIGIN_SCHEMA = z.object({
  // Nodes written before the field existed opened on the list.
  initialView: z
    .enum([SKILL_PICKER_VIEWS.List, SKILL_PICKER_VIEWS.NewSkill])
    .default(SKILL_PICKER_VIEWS.List),
  query: z.string(),
  sessionId: z.string(),
  typed: z.boolean(),
});

export function getContextPickerOrigin(element: TElement) {
  const parsed = CONTEXT_ORIGIN_SCHEMA.safeParse(element.contextOrigin);
  return parsed.success ? parsed.data : null;
}
